import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { List } from "react-virtualized";
import BaseGreeks from "src/apis/mock/data/basegreeks";
import OCRow from "./oc-row";
import styles from "./oc-view1.module.scss";
import { unSubscribeAllGreeksData } from "src/utils/greeks-web-socket";
import { MAX_SCREEN_WIDTH } from "src/utils/constant";
let cutOffIndex = 0;
const RenderOptionChain = ({ optionsChain, id, symbol, isHoverEnabled = true, expiry, position, selectedOptionType, isMultiple, lotSize, activeStrike, spotScripDetails, }) => {
    const getStrikeChainList = () => {
        let localChain = Object.keys(optionsChain || {});
        localChain = localChain.sort((singleElement1, singleElement2) => {
            return Number(singleElement1) - Number(singleElement2);
        });
        return localChain;
    };
    function setHeight() {
        const screenWidth = window.innerWidth;
        return screenWidth;
        // return (
        //   129.5 -
        //   ((screenWidth < MAX_SCREEN_WIDTH ? 5 : 4) -
        //     (getDataFromSession(SESSION_KEYS.GREEKSLIST) || "[]").length) *
        //     16.5
        // );
    }
    const [chain, setChain] = useState(getStrikeChainList());
    const [scrollToIndex, setScrollToIndex] = useState(0);
    useEffect(() => {
        const chain = getStrikeChainList();
        setChain(chain);
        const scrollIndex = chain.findIndex((singleElement) => {
            return singleElement == activeStrike + "";
        });
        if (scrollIndex > 0) {
            if (selectedOptionType != "Greeks") {
                const scrollTo = scrollIndex - 4;
                setScrollToIndex(scrollTo);
            }
            else {
                setScrollToIndex(scrollIndex - 1);
            }
            cutOffIndex = scrollIndex;
        }
        else {
            cutOffIndex = 0;
            setScrollToIndex(0);
        }
    }, [selectedOptionType]);
    useEffect(() => {
        if (selectedOptionType != "Greeks")
            unSubscribeAllGreeksData();
    }, [selectedOptionType]);
    useEffect(() => {
        return () => {
            unSubscribeAllGreeksData();
        };
    }, []);
    const renderRow = (data) => {
        const { index, key, style } = data;
        try {
            if (chain[index] && Object.keys(optionsChain).length > 0) {
                const { PE: { OI: putOI = 0, OI_CHANGE: putOIPerc, LTP: putLTP = 0, PREVIOUS_CLOSE: prevPutClose = 0, PREV_OI: prevOIPut = 0, MAX_OI: putMaxOI = 0, EXCH: putExch = "", EXCH_TYPE: putExchType = "", NAME: putName = "", SCRIPT_CODE: putScripCode = 0, isChecked: isChecked = false, GREEKS_DATA: putGreeksData = BaseGreeks(), }, CE: { OI: callOI = 0, OI_CHANGE: callOIPerc, LTP: callLTP = 0, PREVIOUS_CLOSE: prevCallClose = 0, PREV_OI: prevOICall = 0, MAX_OI: callMaxOI = 0, EXCH: callExch = "", EXCH_TYPE: callExchType = "", NAME: callName = "", SCRIPT_CODE: callScripCode = 0, 
                // isChecked: isChecked = false,
                GREEKS_DATA: callGreeksData = BaseGreeks(), }, } = (optionsChain || {})[chain[index]] || {};
                const priceChangeCall = callLTP - prevCallClose;
                const priceChangePut = putLTP - prevPutClose;
                const callOIChange = callOI - prevOICall;
                const putOIChange = putOI - prevOIPut;
                const callTrend = getTagFromData(priceChangeCall, callOIChange);
                const putTrend = getTagFromData(priceChangePut, putOIChange);
                const callTrendColor = getColorFromTag(callTrend);
                const putTrendColor = getColorFromTag(putTrend);
                return (_jsx("div", Object.assign({ style: style }, { children: _jsx(OCRow
                    // ref={refs[index]}
                    , { strike: chain[index], callOI: callOI, putOI: putOI, callLTP: callLTP, putLTP: putLTP, callTrendColor: callTrendColor, putTrendColor: putTrendColor, callTrend: callTrend, putTrend: putTrend, callOIPerc: callOIPerc, putOIPerc: putOIPerc, callMaxOI: callMaxOI, putMaxOI: putMaxOI, prevOICall: prevOICall, prevOIPut: prevOIPut, prevPutClose: prevPutClose, prevCallClose: prevCallClose, putExch: putExch, putExchType: putExchType, putName: putName, putScripCode: putScripCode, callExch: callExch, callExchType: callExchType, callName: callName, callScripCode: callScripCode, i: index, isHoverEnabled: isHoverEnabled, symbol: symbol, expiry: expiry, position: position, isChecked: isChecked, selectedOptionType: selectedOptionType, putGreeksData: putGreeksData, callGreeksData: callGreeksData, activeStrike: activeStrike, lotSize: lotSize, spotScripDetails: spotScripDetails }, chain[index]) }), key));
            }
            else {
                return _jsx(_Fragment, {});
            }
        }
        catch (err) {
            console.error(err, optionsChain, "optionschain");
            return _jsx(_Fragment, {});
        }
    };
    return (_jsx(List, { style: { width: "100%" }, width: isMultiple ? 650 : 500, height: window.innerWidth > MAX_SCREEN_WIDTH ? 369 : 351, rowHeight: selectedOptionType == "Greeks"
            ? setHeight()
            : selectedOptionType == "Straddle" &&
                window.innerWidth > MAX_SCREEN_WIDTH
                ? 45
                : 40, rowRenderer: renderRow, rowCount: chain.length, scrollToAlignment: "start", scrollToIndex: scrollToIndex }));
};
const ChachedOptionChain = memo(RenderOptionChain);
const OptionChainView1 = ({ optionsChain, id, isHoverEnabled, symbol, expiry, position, selectedOptionType, isMultiple, lotSize, activeStrike, spotScripDetails, }) => {
    return (_jsxs(_Fragment, { children: [selectedOptionType == "Price" && (_jsxs("div", Object.assign({ className: "d-flex dark-head" }, { children: [_jsxs("div", Object.assign({ className: `${styles.tableHeading}` }, { children: [_jsx("span", Object.assign({ className: `mediumWeight medium ` }, { children: "OI" })), _jsx("span", Object.assign({ className: `mediumWeight small ` }, { children: "OI Change" }))] })), _jsxs("div", Object.assign({ className: `${styles.tableHeading}` }, { children: [_jsx("span", Object.assign({ className: `mediumWeight medium ` }, { children: "LTP" })), _jsx("span", Object.assign({ className: `mediumWeight small ` }, { children: "LTP Change" }))] })), _jsx("div", Object.assign({ className: `${styles.tableHeading} strikehead` }, { children: _jsx("span", Object.assign({ className: `mediumWeight medium ` }, { children: "Strike" })) })), _jsxs("div", Object.assign({ className: `${styles.tableHeading}` }, { children: [_jsx("span", Object.assign({ className: `mediumWeight medium ` }, { children: "LTP" })), _jsx("span", Object.assign({ className: `mediumWeight small ` }, { children: "LTP Change" }))] })), _jsxs("div", Object.assign({ className: `${styles.tableHeading}` }, { children: [_jsx("span", Object.assign({ className: `mediumWeight medium ` }, { children: "OI" })), _jsx("span", Object.assign({ className: `mediumWeight small ` }, { children: "OI Change" }))] }))] }))), selectedOptionType == "Straddle" && (_jsxs("div", Object.assign({ className: `${styles.straddleHead}` }, { children: [_jsx("div", Object.assign({ className: styles.col1 }, { children: "Strike" })), _jsx("div", { children: "CE LTP" }), _jsx("div", { children: "PE LTP" }), _jsx("div", { children: "Total Prem." }), _jsx("div", { children: "Breakeven" })] }))), selectedOptionType == "Greeks" && (
            // <div className={`${styles.greeksHead} px-2`}>
            //   <div className="textLeft">
            //     <span className={`mediumWeight medium `}>OI</span>
            //     <br />
            //     <span className={`mediumWeight small `}>OI Change</span>
            //   </div>
            //   <div className="textRight">
            //     <span className={`mediumWeight medium `}>LTP</span>
            //     <br />
            //     <span className={`mediumWeight small `}>LTP Change</span>
            //   </div>
            //   <div className={styles.strikeCol}>Strike</div>
            //   <div className="textLeft">
            //     <span className={`mediumWeight medium `}>LTP</span>
            //     <br />
            //     <span className={`mediumWeight small `}>LTP Change</span>
            //   </div>
            //   <div className="textRight">
            //     <span className={`mediumWeight medium `}>OI</span>
            //     <br />
            //     <span className={`mediumWeight small `}>OI Change</span>
            //   </div>
            // </div>
            _jsx(_Fragment, {})), _jsx("div", Object.assign({ className: `${id == "small-chain"
                    ? styles.chainWrapper
                    : styles.chainWrapperDashboard} chainWrapperDashboard` }, { children: _jsx(ChachedOptionChain, { id: id, optionsChain: optionsChain, isHoverEnabled: isHoverEnabled, expiry: expiry, symbol: symbol, position: position, selectedOptionType: selectedOptionType, isMultiple: isMultiple, lotSize: lotSize, activeStrike: activeStrike, spotScripDetails: spotScripDetails }) }))] }));
};
const getColorFromTag = (tag) => {
    if (tag == "SB") {
        return "rgba(229, 69, 93, 0.55)";
    }
    if (tag == "LB") {
        return "rgba(0, 178, 158, 0.55)";
    }
    if (tag == "LU") {
        return "rgba(229, 69, 93, 0.25";
    }
    if (tag == "SC") {
        return " rgba(0, 178, 158, 0.25)";
    }
    return "";
};
const getTagFromData = (priceChange, oiChange) => {
    if (priceChange >= 0 && oiChange >= 0) {
        return "LB";
    }
    if (priceChange < 0 && oiChange >= 0) {
        return "SB";
    }
    if (priceChange < 0 && oiChange < 0) {
        return "LU";
    }
    if (priceChange >= 0 && oiChange < 0) {
        return "SC";
    }
    return "";
};
export default memo(OptionChainView1);
